import { SVGProps } from 'react';

const IcAccount = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='32'
      height='32'
      viewBox='0 0 32 32'
      fill='none'
      {...props}
    >
      <path
        d='M15.9146 1.336C20.6594 1.33614 24.5054 5.18291 24.5054 9.9278C24.5053 12.4669 23.4031 14.7476 21.6519 16.3204C25.8585 16.9341 29.0892 20.5558 29.0894 24.9327V27.7628C29.0892 29.365 27.7902 30.6639 26.188 30.6641H5.81201C4.20979 30.6639 2.91082 29.365 2.91064 27.7628V24.9327C2.91083 20.6065 6.06732 17.019 10.2026 16.3438C8.43626 14.7703 7.3228 12.4795 7.32275 9.9278C7.32275 5.18282 11.1696 1.336 15.9146 1.336ZM11.6157 19.1299C8.41081 19.1299 5.81222 21.7278 5.81201 24.9327V27.7628H26.188V24.9327C26.1878 21.7278 23.5892 19.1299 20.3843 19.1299H11.6157ZM15.9146 4.23737C12.7721 4.23737 10.2241 6.78535 10.2241 9.9278C10.2242 13.0702 12.7722 15.6172 15.9146 15.6172C19.0568 15.6171 21.6039 13.0701 21.604 9.9278C21.604 6.78544 19.0569 4.23751 15.9146 4.23737Z'
        fill='#0561AE'
      />
    </svg>
  );
};

export default IcAccount;
